import debounce from 'lodash.debounce';
import ParallaxItem from './parallaxItem';

export default class ParallaxController {
  constructor(selector) {
    this.selector = selector;
    this.parallaxItems = [];
    this.visibleItems = [];
    this.watchingScroll = false;
    this.documentHeight = document.documentElement.clientHeight;
    this.documentWidth = document.documentElement.clientWidth;
    this.onScroll = this.onScroll.bind(this);
    this.animateItems = this.animateItems.bind(this);
    this.createParallaxItems();
    window.addEventListener(
      'resize',
      debounce(() => {
        this.onResize();
      }, 400)
    );
  }

  createParallaxItems() {
    const parallaxElements = [].slice.call(document.querySelectorAll(this.selector));
    parallaxElements.forEach((element) => {
      const speed = element.dataset.parallaxSpeed ? element.dataset.parallaxSpeed * 0.05 : 0.05;
      const direction = element.dataset.parallaxDirection
        ? element.dataset.parallaxDirection
        : 'up';
      const multiplier = direction === 'up' ? -speed : speed;
      const parallaxItem = new ParallaxItem(element, multiplier);
      parallaxItem.on('intersect', this.visibilityChanged.bind(this));
      this.parallaxItems.push(parallaxItem);
    });
  }

  onResize() {
    if (
      document.documentElement.clientHeight != this.documentHeight ||
      document.documentElement.clientWidth != this.documentWidth
    ) {
      this.documentHeight = document.documentElement.clientHeight;
      this.documentWidth = document.documentElement.clientWidth;
      this.parallaxItems.forEach((item) => {
        requestAnimationFrame(() => {
          item.calculateDimensions();
        });
      });
    }
  }

  onScroll() {
    if (this.parallaxItems.filter((item) => item.isUpdating).length === 0) {
      requestAnimationFrame(this.animateItems);
    }
  }

  animateItems() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';
    var y = supportPageOffset
      ? window.pageYOffset
      : isCSS1Compat
      ? document.documentElement.scrollTop
      : document.body.scrollTop;

    this.visibleItems.forEach((item) => {
      item.updateTransform(y);
    });
  }

  visibilityChanged() {
    this.visibleItems = this.parallaxItems.filter((item) => item.isVisible);
    if (this.visibleItems.length > 0) {
      if (!this.watchingScroll) {
        this.watchingScroll = true;
        window.addEventListener('scroll', this.onScroll);
      }
    } else {
      if (this.watchingScroll) {
        this.watchingScroll = false;
        window.removeEventListener('scroll', this.onScroll);
      }
    }
  }
}
